import React, { useState } from "react";
import { ChevronDown, CheckCircle2 } from "lucide-react";
import { fmtDateTime } from "../lib/api";

export const bundleTitle = (p) => `${p.package_name} · ${p.bundle_left}/${p.bundle_size}`;

export const CheckinHistory = ({ p }) => {
  const [open, setOpen] = useState(false);
  const list = p.checkins || [];
  if (!p.bundle_size || list.length === 0) return null;
  return (
    <div className="pl-2 mt-2">
      <button onClick={() => setOpen((o) => !o)} data-testid={`checkin-history-toggle-${p.id}`} className="flex items-center gap-1 text-[#D4AF37] text-sm">
        Check-in history ({list.length}) <ChevronDown size={15} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul data-testid={`checkin-history-${p.id}`} className="mt-2 space-y-1.5">
          {list.map((c, i) => (
            <li key={c.id} className="flex items-center gap-2 text-xs text-[#E8E4F0]">
              <CheckCircle2 size={14} className="text-[#4ADE80] shrink-0" /> Pass {i + 1} checked in · {fmtDateTime(c.at)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
